import { get, patch, post } from '@fable/api'
import {
  Stats,
  StatsListResponse,
  StatsPartialResponse,
  StatsPlatform,
  StatsResponse,
  StatsYearListResponse,
} from '../types'
import { isAndroidParam } from '../utils'

export const getUserStats = async ({
  userId,
  year,
}: {
  userId: string
  year?: number
}) => {
  let url = `/users/${userId}/stats/`

  if (year) url += `?year=${year}`

  const res = await get(url)
  return res as StatsListResponse
}

export const getUserCurrentStats = async (
  userId: string
): Promise<StatsResponse> => {
  const res = await get(`/users/${userId}/stats/current/`)
  return res as StatsResponse
}

export const createUserStats = async (
  userId: string
): Promise<StatsResponse> => {
  const zoneName = Intl.DateTimeFormat().resolvedOptions().timeZone
  const payload: { zone_name: string; platform?: StatsPlatform } = {
    zone_name: zoneName,
  }

  if (isAndroidParam) payload.platform = 'android'

  const res = await post(`/users/${userId}/stats/`, payload)
  return res as StatsResponse
}

export const updateUserStats = async ({
  userId,
  statsId,
  data,
}: {
  userId: string
  statsId: string
  data: Partial<Stats>
}): Promise<StatsPartialResponse> => {
  const res = await patch(`users/${userId}/stats/${statsId}`, data)
  return res as StatsPartialResponse
}

export const getStatsYearList = async (
  userId: string
): Promise<StatsYearListResponse> => {
  const res = await get(`users/${userId}/stats/years/`)
  return res as StatsYearListResponse
}

export const updateStatsGoalOptIn = async ({
  userId,
  optIn,
}: {
  userId: string
  optIn: boolean
}) => await post(`users/${userId}/stats/goal_opt_in/`, { opt_in: optIn })

export const getStatsByYear = async ({
  userId,
  year,
}: {
  userId: string
  year: number
}) =>
  (await get(
    `users/${userId}/stats/annual_stats?year=${year}`
  )) as StatsResponse

export const updateStatsPrivacy = async ({
  userId,
  isPrivate,
}: {
  userId: string
  isPrivate: boolean
}) => await post(`users/${userId}/stats/privacy/`, { is_private: isPrivate })
